//import router from '@/router';
import jwtToken from '@/plugins/jwt/jwt-token.js';
import user from '@/plugins/jwt/user.js';
import axios from 'axios';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { startRequest, endRequest } from '@/plugins/loading';
import { apiError } from '@/plugins/errors';

let endpoint;

if (process.env.NODE_ENV === 'production') {
  endpoint = {
    url: "https://new.jurisleg.com",// front jurisleg/HexCRM
    intranetUrl: "https://red.jurisleg.com/",// intranet jurisleg
    baseUrl: "https://api.jurisleg.com/",// back jurisleg/HexCRM
    metabrokerUrl: "https://metadev.infutura.es/" // metabroker (hub compartido)
  };
} else {
  endpoint = {
    url: "http://localhost:8080",// url de front (aqui)
    intranetUrl: "http://localhost:8001/",// url de front (aqui)
    baseUrl: "http://localhost:8000/",// url del back (aqui)
    metabrokerUrl: "http://localhost:9080/"// url del metabroker
  };
}


const Toast = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

let showToastAuthorization = true;

axios.defaults.baseURL = endpoint.baseUrl;

axios.interceptors.request.use(
  (config) => {
    startRequest();
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    if (jwtToken.getToken()) {
      config.headers['Authorization'] = 'Bearer ' + jwtToken.getToken();
      config.headers['UnitId'] = user.getUnit();
    }
    config.baseURL = determineBaseURL(config.url);
    
    const isMetabrokerURL = config.url.includes('/metabroker');

    if (isMetabrokerURL) {
      config.url = config.url.replace('/metabroker', '');
    }

    return config;
  },
  (error) => {
    endRequest();
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    endRequest();
    if (
      response.data.status == 'Token has Expired' ||
      response.data.status == 'Token not provided' ||
      response.data.status == 'Token is Invalid' ||
      response.data.status == 'Authorization Token not found'
    ) {
      jwtToken.removeToken();
      window.location.href = endpoint.intranetUrl + '#/pages/login?callback=' + encodeURIComponent(endpoint.url);
      //router.push({ path: '/pages/login' });
    }
    return response;
  },
  (error) => {
    endRequest();
    console.log(error);

    let errorResponseData = error?.response?.data;

    const errors = [
      'token_invalid',
      'Token not provided',
      'Token has expired',
      'Token is invalid',
      'token_expired',
      'token_not_provided',
      'Expired JWT Token',
      'JWT Token not found',
      'Token is Expired',
    ];


    if (errors.includes(errorResponseData?.message)) {
      jwtToken.removeToken();
      //router.push({ path: '/pages/login' });
      window.location.href = endpoint.intranetUrl + '#/pages/login?callback=' + encodeURIComponent(endpoint.url);
    }

    // Los componentes que muestran su propio mensaje pasan { skipErrorToast: true }.
    if (error?.response?.status == 422 && !error?.config?.skipErrorToast) {
      let html = '';

      for (let key in error['response']['data']['errors']) {
        for (let message in error['response']['data']['errors'][key]) {
          html += error['response']['data']['errors'][key][message] + '<br>';
        }
      }

      Toast.fire({
        icon: 'error',
        title: 'Revisa el formulario',
        html: html || apiError(error),
      });
    }

    if (error?.response?.status == 500) {
      if (error.config.url != "v1/customers/find_by_dni" && !error?.config?.skipErrorToast) {
        // Mensaje limpio para el usuario (nada de "Server Error Linea undefined").
        Toast.fire({
          icon: 'error',
          title: 'No se pudo completar la operación',
          html: apiError(error),
        });
      }
    }

    if (error?.response?.status == 401) {
      if (showToastAuthorization) {
        showToastAuthorization = false;
        Toast.fire({
          icon: 'error',
          title: 'Sesión expirada',
          html: 'Vuelva a iniciar Sesión',
        });
        window.location.href = endpoint.intranetUrl + '#/pages/login?callback=' + encodeURIComponent(endpoint.url);
        //router.push({ path: '/pages/login' });
        setTimeout(() => {
          showToastAuthorization = true;
        }, 4000);
      }
    }

    return Promise.reject(error);
  }
);

function determineBaseURL(url) {
  if (url.startsWith('/metabroker')) {
    return endpoint.metabrokerUrl;
  } else {
    return endpoint.baseUrl;
  }
}
